import { apiService } from './api';

export const categoryService = {
  getAll: async () => {
    try {
      const response = await apiService.get('/Category/all');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch categories');
    }
  },

 getAllTutorial: async () => {
    try {
      const response = await apiService.get('/Category/tutorials');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch categories');
    }
  },


   getAllBlogs: async () => {
    try {
      const response = await apiService.get('/Category/blogs');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch categories');
    }
  },


  getById: async (id) => {
    try {
      const response = await apiService.get(`/Category/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch category');
    }
  },

  create: async (categoryData) => {
    try {
      const response = await apiService.post('/Category/create', categoryData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create category');
    }
  },


  update: async (id, categoryData) => {
    try {
      const response = await apiService.put(`/Category/${id}`, categoryData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update category');
    }
  },

  delete: async (id) => {
    try {
      const response = await apiService.delete(`/Category/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete category');
    }
  }
}; 